<script>
import { checkConsentMixin } from './check-consent-mixin'
import loadScript from './load-script'

export default {
  mixins: [checkConsentMixin],

  props: {
    containerId: {
      type: String,
      required: true
    }
  },

  methods: {
    trackPage() {
      window.dataLayer.push({'gtm.start': new Date().getTime(), event:'gtm.js'})
      loadScript(`https://www.googletagmanager.com/gtm.js?id=${this.containerId}`)
    }
  }
}
</script>
